<template>
  <div class="downline-report">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-share"></i> Downline Report</span>
      </div>

      <el-form :inline="true" :model="query" size="medium">
        <el-form-item label="Search">
          <el-input
            prefix-icon="el-icon-search"
            placeholder="Introducer / Downline Code"
            v-model="query.search"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="Search Date">
          <el-date-picker
            v-model="dateSearch"
            type="daterange"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="loading"
            @click="getReport()"
            >Query</el-button
          >
          <el-button icon="el-icon-download" type="success" @click="ExcelReport()">Excel</el-button>
        </el-form-item>
      </el-form>

      <div class="table-area" v-loading="loading">
        <data-tables
          :data="dataTable"
          border
          :page-size="20"
          :pagination-props="{ background: true, pageSizes: [20, 50, 100, 200] }"
        >
          <el-table-column prop="introducer_membercode" label="Introducer" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="introducer_vender" label="API" header-align="center" align="center" width="120"> </el-table-column>
          <el-table-column prop="downline_membercode" label="Downline" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="downline_vender" label="API" header-align="center" align="center" width="120"> </el-table-column>
          <el-table-column prop="benefit" label="Benefit" header-align="center" align="center" width="100">
            <template slot-scope="scope">
              <el-tag
                size="mini"
                effect="dark"
                :type="scope.row.benefit === 'Yes' ? 'success' : 'info'"
                >{{ scope.row.benefit }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column prop="approve_date" label="Approve Date" header-align="center" align="center" width="180"> </el-table-column>
        </data-tables>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getDownlineReport, reportDownlineReportExcel } from "@/api/introducer";

export default {
  data() {
    return {
      loading: false,
      dataTable: [],
      dateSearch: "",
      query: {
        search: "",
        startDate: "",
        endDate: "",
      },
    };
  },
  methods: {
    getReport() {
      this.loading = true;
      this.SelectDate();
      getDownlineReport(this.query).then(({ result, data }) => {
        this.loading = false;
        if (result) {
          this.dataTable = data;
        }
      });
    },
    SelectDate() {
      const range = this.dateSearch || [];
      this.query.startDate = range[0] || "";
      this.query.endDate = range[1] || "";
    },
    ExcelReport() {
      this.SelectDate();
      reportDownlineReportExcel(this.query);
    },
  },
  mounted() {
    this.getReport();
  },
};
</script>

<style lang="scss">
.downline-report {
  .table-area {
    min-height: 200px;
  }
}
</style>
